import '@/assets/reset.css'
import 'leaflet/dist/leaflet.css';

import Vue from 'vue'

import App from './components/App.vue'

import VueObserveVisibility from 'vue-observe-visibility'
import vClickOutside from 'v-click-outside'
import { Fragment } from 'vue-frag'
import _ from 'underscore'
import tooltip from 'v-tooltip'
import PortalVue from 'portal-vue'
import moment from 'moment-timezone'
import observer from 'vue-mutation-observer'

import constants from './constants'
import router from './router'
import store from './store'
import pubsub from './pubsub'
import api from './api'
import util from './util'

import mixInjection from './mixin/injection'
import mixShortcuts from './mixin/shortcuts'
import mixWindow from './mixin/window'

Vue.config.productionTip = false

var requireComponentGlobal = require.context('./components/common', true, /[A-Z]\w+\.(vue|js)$/)

requireComponentGlobal.keys().forEach(function(filename) {

	var componentConfig = requireComponentGlobal(filename)
	var componentName = filename.replace(/\//g, '').replace('.vue', '').replace('.', '').replace(/([A-Z])/g, '-$1').toLowerCase().substring(1)

	Vue.component(
		componentName,
		componentConfig.default
	)

})

Vue.directive('is', {

	bind: function(el, e) {
	
		if(e.value) {
		
			el.classList.add('is-' + e.arg)

		} else {
		
			el.classList.remove('is-' + e.arg)

		}
	
	},

	update: function(el, e) {
	
		if(e.value) {
		
			el.classList.add('is-' + e.arg)

		} else {
		
			el.classList.remove('is-' + e.arg)

		}
	
	}

})

Vue.directive('bgimage', {

	bind: function (el, binding) {

		if (binding.value !== undefined) {

			var file = binding.value

			if (_.isString(file)) {

				if (file.indexOf('https:') === 0) {
				
					file = file.replace(process.env.VUE_APP_API, process.env.VUE_APP_BUNNY)

					if (file.indexOf('img.geekgroup.app') > 0) {
					
						file = file + '/large'
					
					}

					if(binding.arg === 'thumb') {
					
						file = file + '?width=256&height=256'
					
					} else if(binding.arg === 'card') {
					
						file = file + '?width=512&height=512'
					
					}
				
				}

				el.style.backgroundImage = (binding.value) ? 'url("' + file + '")' : false

			} else {
			
				el.style.backgroundImage = ''
			
			}

		}

	},

	update: function (el, binding) {

		if (binding.value !== undefined) {

			if(binding.value) {

				var file = binding.value

				if (_.isString(file)) {

					if (file.indexOf('https:') === 0) {
					
						file = file.replace(process.env.VUE_APP_API, process.env.VUE_APP_BUNNY)

						if(binding.arg === 'thumb') {
						
							file = file + '?width=256&height=256'
						
						} else if(binding.arg === 'card') {
					
							file = file + '?width=512&height=512'
						
						}
						
					}
		
					el.style.backgroundImage = (binding.value) ? 'url("' + file + '")' : false

				} else {
				
					el.style.backgroundImage = ''
				
				}
				
			} else {

				el.style.backgroundImage = ''

			}

		}

	}

})

Vue.directive('bgcolor', {

	bind: function (el, binding) {

		el.style.backgroundColor = (binding.value) ? '#' + binding.value : false

	},

	update: function (el, binding) {

		el.style.backgroundColor = (binding.value) ? '#' + binding.value : false

	}

})

Vue.filter('capitalise', function (value) {

	return value.charAt(0).toUpperCase() + value.slice(1)

})

Vue.filter('fromNow', function (value) {

	return (value) ? moment.unix(value).local().fromNow() : ''

})

Vue.filter('daysSince', function (value) {

	return (value) ? moment().utc().diff(moment.unix(value).utc(), 'days') : ''

})

Vue.filter('daysBetween', function (from, to) {

	return (from) ? Math.abs(moment.unix(to).utc().diff(moment.unix(from).utc(), 'days')) : ''

})

Vue.filter('formatDate', function (value, format) {

	return (value) ? moment.unix(value).utc().format(format) : ''

})

Vue.filter('round', function (value, decimals, force) {

	force = force || false
	value = parseFloat(value)

	return ((value % 1 !== 0 || force) && value !== undefined) ? value.toFixed(decimals) : value

})

Vue.filter('nth', function (value) {

	var remainder = value % 10

	if (remainder === 1 && value !== 11) return value.toString() + 'st'
	if (remainder === 2 && value !== 12) return value.toString() + 'nd'
	if (remainder === 3 && value !== 13) return value.toString() + 'rd'

	return value.toString() + 'th'

})

Vue.filter('prettyNumber', function (value) {

	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

})

Vue.filter('hours', function (value) {

	return value / 60 / 60

})

Vue.filter('asHours', function (value, decimals) {

	decimals = decimals || 0

	value = value / 60 / 60

	value = parseFloat(value)

	return ((value % 1 !== 0) && value !== undefined) ? value.toFixed(decimals) : value

})

Vue.use(tooltip)
Vue.use(vClickOutside)
Vue.use(VueObserveVisibility)
Vue.use(PortalVue)
Vue.use(observer)

Vue.mixin(mixWindow)
Vue.mixin(mixInjection)
Vue.mixin(mixShortcuts)

Vue.component('Fragment', Fragment)

new Vue({
	_,
	moment,
	router,
	constants,
	util,
	store,
	api,
	pubsub,
	render: h => h(App),
	created: function() {

		pubsub.$emit('window.initiated')

	}
}).$mount('#app')
